module.exports = __webpack_public_path__ + "static/media/uniteam.8ff6f75a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/uniteam.svg
// module id = 252
// module chunks = 0